import { render, staticRenderFns } from "./leeBotChat.vue?vue&type=template&id=02320c0b&scoped=true&"
import script from "./leeBotChat.vue?vue&type=script&lang=js&"
export * from "./leeBotChat.vue?vue&type=script&lang=js&"
import style0 from "./leeBotChat.vue?vue&type=style&index=0&id=02320c0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02320c0b",
  null
  
)

export default component.exports